import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { Action } from "@ngrx/store";
import { Observable, of } from "rxjs";
import { catchError, map, mergeMap, tap } from "rxjs/operators";
import * as GameActions from "../actions/game.actions";
import { Book } from "src/app/models/game";
import { jsonData } from "src/assets/jsonData";
import { ActivatedRoute, Router } from "@angular/router";

@Injectable()
export class GameEffects {
  constructor(
    private http: HttpClient,
    private action$: Actions,
    private router: Router,
    private route: ActivatedRoute
  ) {}

  private ApiURL = "http://localhost:3000/books";
  private jsonData = of(jsonData);

  GetGameData$: Observable<Action> = createEffect(() =>
    this.action$.pipe(
      ofType(GameActions.getGameData),
      mergeMap((action) =>
        this.jsonData.pipe(
          map((data: Book[]) => {
            return GameActions.SuccessGetGameDataAction({ payload: data });
          }),
          catchError((error: Error) => {
            return of(GameActions.ErrorGameDataAction(error));
          })
        )
      )
    )
  );

  navigateToEnglishToJapanese$ = createEffect(
    () =>
      this.action$.pipe(
        ofType(GameActions.playEnglishToJapanese),
        tap(() => {
          this.router.navigate(["games/english-to-japanese"]);
        })
      ),
    { dispatch: false }
  );

  navigateToJapaneseToEnglish$ = createEffect(
    () =>
      this.action$.pipe(
        ofType(GameActions.playJapaneseToEnglish),
        tap(() => {
          this.router.navigate(["games/japanese-to-english"]);
        })
      ),
    { dispatch: false }
  );
}
